import React from 'react';
import * as Yup from 'yup';
import {Formik} from 'formik';
import {Box, Button, Container, makeStyles, TextField, Typography} from '@material-ui/core';
import Page from '../../components/Page';
import {login} from "../../redux/actions/authAction";
import {useDispatch, useSelector} from "react-redux";
import {Alert} from "@material-ui/lab";
import {NavLink as RouterLink} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        height: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const LoginView = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {error, errorMessage} = useSelector(state => state.auth);
    const handleSubmit = (values, setSubmitting) => {
        dispatch(login(values.username, values.password, setSubmitting));
    };


    return (
        <Page
            className={classes.root}
            title="Login"
        >
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <Formik
                        initialValues={{
                            username: '',
                            password: ''
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().max(25).required('Username is required'),
                            password: Yup.string().max(25).required('Password is required')
                        })}
                        onSubmit={(values,{setSubmitting}) => {
                            handleSubmit(values, setSubmitting);
                        }}
                    >
                        {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              isSubmitting,
                              touched,
                              values
                          }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <Typography color="textPrimary" variant="h2"> Smart Piggy </Typography>
                                    <Typography color="textSecondary" gutterBottom variant="body2">
                                        Sign in on the platform
                                    </Typography>
                                </Box>
                                {error && <Alert severity="error">{errorMessage}</Alert>}
                                <TextField
                                    error={Boolean(touched.username && errors.username)}
                                    fullWidth
                                    helperText={touched.username && errors.username}
                                    label="Username"
                                    margin="normal"
                                    name="username"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.username}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.password && errors.password)}
                                    fullWidth
                                    helperText={touched.password && errors.password}
                                    label="Password"
                                    margin="normal"
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="password"
                                    value={values.password}
                                    variant="outlined"
                                />
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        Sign in now
                                    </Button>
                                </Box>
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        component={RouterLink}
                                        to={"/singup"}
                                        variant="contained"
                                    >
                                        Sign up
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Box>
        </Page>
    );
};

export default LoginView;
